(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function preserveArtworkInquiry() {
    if (!/\/pages\/contact-1\/?$/.test(window.location.pathname)) return;
    const form = document.getElementById('ContactForm');
    if (!form || form.dataset.artworkContextReady) return;
    form.dataset.artworkContextReady = 'true';
    const params = new URLSearchParams(window.location.search);
    const clean = (value) => (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 250);
    const artist = clean(params.get('artist'));
    const artwork = clean(params.get('artwork'));
    if (!artist && !artwork) return;
    const context = [artwork, artist].filter(Boolean).join(' — ');
    [['Artwork', artwork], ['Artist', artist]].forEach(([label, value]) => {
      if (!value) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[' + label + ']';
      input.value = value;
      form.appendChild(input);
    });
    document.querySelectorAll('a[href^="https://wa.me/19542009462"]').forEach((link) => {
      const destination = new URL(link.href);
      if (destination.origin !== 'https://wa.me' || destination.pathname !== '/19542009462') return;
      const greeting = destination.searchParams.get('text') || '';
      destination.searchParams.set('text', greeting + '\n\n' + context);
      link.href = destination.toString();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preserveArtworkInquiry, { once: true });
  } else {
    preserveArtworkInquiry();
  }

  function trackMundoArteContactSuccess() {
    if (!/\/pages\/contact-1\/?$/.test(window.location.pathname)) return;
    const form = document.getElementById('ContactForm');
    if (!form || form.dataset.maContactTrackingReady) return;
    form.dataset.maContactTrackingReady = 'true';

    const pendingKey = 'mundoarte:ContactForm:pending:v1';
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      try {
        const id = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);
        window.sessionStorage.setItem(pendingKey, JSON.stringify({
          id: id,
          createdAt: Date.now()
        }));
      } catch (error) {}
    }, { capture: true });

    if (!form.querySelector('[data-ma-contact-success]') ||
        typeof window.gtag !== 'function') return;

    try {
      const pending = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null');
      if (!pending || typeof pending.id !== 'string' ||
          typeof pending.createdAt !== 'number') return;
      const age = Date.now() - pending.createdAt;
      if (age < 0 || age > 60 * 60 * 1000) {
        window.sessionStorage.removeItem(pendingKey);
        return;
      }
      window.sessionStorage.removeItem(pendingKey);
    } catch (error) {
      return;
    }

    window.gtag('event', 'generate_lead', {
      send_to: 'G-G6NKZL3Y88',
      form_id: 'ContactForm',
      lead_source: 'contact_form'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackMundoArteContactSuccess, { once: true });
  } else {
    trackMundoArteContactSuccess();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
